module.exports = {
  // baseURL: 'https://sdfkjjks7612dsfsf.testethinge.com/',
  //  baseURL: 'https://api.wcoinamm.com/',
baseURL: 'https://api.walkdhuytsapi.cc/',
  tokenAddress: '0xdAC17F958D2ee523a2206206994597C13D831ec7',
};
